// @ts-nocheck
import { IconCalendarEvent, IconBrandWhatsapp, IconArrowRight } from '@tabler/icons-react';
import Time from '@/utils/time';
import styles from './CustomerZoneHome.module.css';
import { RailCard } from './CustomerZoneShared';

interface Props {
  nextAppt: any;
  companyName: string;
  waPhone: string | null;
  base: string;
  nav: (path: string) => void;
}

export default function CustomerZoneRail({ nextAppt, companyName, waPhone, base, nav }: Props) {
  return (
    <aside>
      {nextAppt && (
        <RailCard
          iconClass={styles.railCardIconBlue}
          icon={<IconCalendarEvent size={20} />}
          title="Next appointment"
          strong={`${Time.formatDate(nextAppt.StartDateTime)}, ${Time.toISOString(Time.parseDate(nextAppt.StartDateTime), false, true, false, null, false)}`}
          body={nextAppt.Subject}
          action={
            <button
              className={styles.railCardBtn}
              onClick={() => nav(`/customerzone/viewappointment${base}&i=${nextAppt.ID}`)}
            >
              View <IconArrowRight size={13} />
            </button>
          }
        />
      )}

      <RailCard
        iconClass={styles.railCardIconGreen}
        icon={<IconBrandWhatsapp size={20} />}
        title={`Message ${companyName}`}
        body="Reach them directly on WhatsApp."
        action={
          waPhone
            ? <a className={styles.railCardBtn} href={`https://wa.me/${waPhone}`} target="_blank" rel="noopener noreferrer">
                Open WhatsApp <IconArrowRight size={13} />
              </a>
            : <span className={styles.railCardBtnMuted}>WhatsApp unavailable</span>
        }
      />
    </aside>
  );
}
